import React from 'react'
import PropTypes from 'prop-types'

import TRACKERS from '@helpers/trackers'


/* Example of use:
<Tracker display='block' data={
  {
    ga: {
      type: '_trackEvent',
      element: 'button-x',
      event: 'clicked',
    },
  }
}>
  Home
</Tracker>
*/


class Tracker extends React.Component {

  _handleClick() {
    TRACKERS.bi(this.props.data)
  }

  render() {

    return (
      <div onClick={this._handleClick.bind(this)} className={(this.props.display)}>
        {this.props.children}
      </div>
    )

  }
}

Tracker.propTypes = {
  data: PropTypes.object.isRequired,
}

export default Tracker



// WEBPACK FOOTER //
// ./src/components/shared/elements/Tracker.js